import React, { useState } from 'react';
import _ from 'lodash';
import { Icon } from 'antd';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import { getCandidates } from '../../Reducers/CandidateReducer';
import { getCandidatesConnectInfo } from '../../Reducers/ConnectReducer';
import { getCandidateStatus } from '../../Utils/SourceUtils';
import * as candidateActions from '../../Actions/CandidateActions';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import MessageWindowContainer from '../../Containers/MessageWindow/MessageWindow';
import { getFeatureToggleList } from '../../Reducers/FeatureToggleReducer.ts';
import styles from '../AllEmails/AllEmails.module.scss';
import * as connectActions from '../../Actions/ConnectActions';
import { getAllMessageConversationCount } from '../../Reducers/MessageConversationsReducer';

const mapStateToProps = (state, props) => {
  const { candidateId } = props;
  const candidatesById = getCandidates(state);
  const candidate = { ..._.get(candidatesById, [candidateId], {}) };
  const latestAllSmsCount = getAllMessageConversationCount(state, candidate.PersonId);
  return {
    connectInfo: getCandidatesConnectInfo(state),
    candidatesById,
    featureToggleList: getFeatureToggleList(state),
    latestAllSmsCount,
  };
};

const mapDispatchToProps = {
  fetchCandidateDetails: candidateActions.fetchCandidateDetails,
  fetchLatestMessages: connectActions.fetchLatestMessages,
};

function AllSMS(props) {
  const {
    jobId,
    candidateId,
    candidatesById,
    version,
    connectInfo,
    fetchCandidateDetails,
    featureToggleList,
    setCount,
    openJobViewInNewTabCallBack,
    fetchLatestMessages,
    latestAllSmsCount,
  } = props;
  const {
    AllConversations: { IsEnabled: isAllConversationsEnabled },
  } = featureToggleList;

  const candidateInfo = { jobId: null, Id: candidateId };
  const pushCandInfo = { Country: null };
  const [isCandidateViewHeaderVisible, setCandidateViewHeaderVisible] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState(null);
  const allSmsRef = React.useRef(null);
  const [isComposeMessageModalVisible, setMessageComposeModalVisibility] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState(null);
  const [messageTab, setMessageTab] = React.useState(null);
  const [currentSMSPage, setCurrentSMSPage] = useState(1);

  const fetchAndSetCandidateDetails = async () => {
    const _candidateDetails = await fetchCandidateDetails(candidateInfo, pushCandInfo, true);
    setCandidateDetails(_candidateDetails);
  };

  React.useEffect(() => {
    fetchAndSetCandidateDetails();
  }, []);

  if (!candidateDetails) {
    return <LoadingScreen loading active />;
  }

  const connectStatuses = connectInfo.ConnectStatuses || {};
  const candidate = { ..._.get(candidatesById, [candidateId], {}) };
  const { Id: userId } = candidate;
  const connectStatus = candidate ? _.get(connectStatuses, candidate.PersonId, {}) : {};
  const availableProviders = _.get(connectStatus, 'Contact.AvailableProviders', null);
  const candidateStatus = getCandidateStatus(_.get(candidate, ['Sources'], []));

  return isAllConversationsEnabled ? (
    <div className={styles.infiniteScrollDiv}>
      <InfiniteScroll
        useWindow={false}
        initialLoad={false}
        loadMore={() => {
          fetchLatestMessages(null, candidateDetails.PersonId, userId, 'Success', 'SMS', null, currentSMSPage * 10, 10);
          setCurrentSMSPage(currentSMSPage + 1);
        }}
        loader={
          <div key="loader" className={styles.loader}>
            <Icon className={styles.loadingIcon} type="loading" spin />
          </div>
        }
        threshold={150}
        hasMore={currentSMSPage * 10 < latestAllSmsCount}
      >
        <MessageWindowContainer
          conversationId={null}
          personId={candidate.PersonId}
          availableProviders={availableProviders}
          candidate={candidate}
          jobId={jobId}
          candidateStatus={candidateStatus}
          currentJobDetails={{}}
          candidateContext="job"
          version={version}
          ref={allSmsRef}
          isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
          isComposeMessageModalVisible={isComposeMessageModalVisible}
          setMessageComposeModalVisibility={setMessageComposeModalVisibility}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          setMessageTab={setMessageTab}
          isAllSMS
          setCount={setCount}
          isComposeMessageDisabled
          openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
          isAllConversations
          setSMSPage={setCurrentSMSPage}
        />
      </InfiniteScroll>
    </div>
  ) : null;
}

export default connect(mapStateToProps, mapDispatchToProps)(AllSMS);
